import React from 'react';
import PropTypes from 'prop-types';
import styles from './location-details.module.scss';
import Icon from '@components/icon';
import { classNames } from '@utils';

const ListItem = props => (
	<div className={styles.item}>
		<div className={styles.icon}>
			<Icon name="check" />
		</div>
		<div className={styles.description}>{props.description}</div>
	</div>
);

const ListColumn = props => {
	return (
		!!props.column.length && (
			<div className={styles.column}>
				{props.column.map(({ description }, i) => {
					return <ListItem key={i} description={description} />;
				})}
			</div>
		)
	);
};

const LocationDetails = props => {
	return (
		<section className={classNames(styles.section, props.reverse && styles.isReverse)} data-theme={props.theme}>
			<div className={styles.media}>{props.image && <img className={styles.image} src={props.image} />}</div>
			<div className={styles.heading}>
				<h3 className={styles.title}>{props.title}</h3>
			</div>
			<div className={styles.columns}>
				<ListColumn column={props.column1} />
				<ListColumn column={props.column2} />
			</div>
		</section>
	);
};

LocationDetails.propTypes = {
	image: PropTypes.string,
	title: PropTypes.string,
	column1: PropTypes.arrayOf(PropTypes.object),
	column2: PropTypes.arrayOf(PropTypes.object),
	reverse: PropTypes.bool,
	theme: PropTypes.oneOf(['blue', 'yellow', 'red'])
};

LocationDetails.defaultProps = {
	column1: [],
	column2: [],
	reverse: false,
	theme: 'blue'
};

export default LocationDetails;
